import React from "react";

const Outro = ({ children }) => {
  return <p className="outro">{children}</p>;
};

export default Outro;
